import getPostedByForExport from '../../utils/getPostedByForExport'
export const eventExportColumns = [
	{ label: 'Sr No', key: 'index' },

	{
		label: 'Event Title',
		render: e => e?.title || '',
	},

	{
		label: 'Category',
		render: e => e?.category || '',
	},

	{
		label: 'Community',
		render: e => e?.hub?.name || '',
	},

	{
		label: 'Sanstha',
		render: e => e?.sanstha?.name || '',
	},

	{
		label: 'Recived Amount (Rs)',
		render: e => e?.receivedAmount || 0,
	},

	{
		label: 'Start Time',
		render: e => e?.startTime || '—',
	},

	{
		label: 'End Time',
		render: e => e?.endTime || '—',
	},

	{
		label: 'Start Date',
		render: e => (e?.startDate ? new Date(e.startDate).toLocaleDateString() : ''),
	},

	{
		label: 'End Date',
		render: e => (e?.endDate ? new Date(e.endDate).toLocaleDateString() : ''),
	},

	{
		label: 'Event Type',
		render: e => (e?.eventpaid ? 'Paid' : 'Free'),
	},

	// {
	// 	label: 'Amount',
	// 	render: e => (e?.eventpaid ? e?.amount || '0' : '—'),
	// },

	{
		label: 'Status',
		render: e => e?.status || '',
	},
	{
		label: 'Event Posted By',
		render: e => getPostedByForExport(e),
	},
]
